import styled from '@emotion/styled';
import { device } from '../../constants/breakpoint';

export const BaseContent = styled.div`
    margin: 0 auto;
    width: 1080px;
    @media screen and ${device.laptopL} {
        width: 1024px;
    }
    @media screen and ${device.laptop} {
        width: 768px;
    }
    @media screen and ${device.mobile} {
        width: 80%;
    }
`;
